import { Facility } from './facility';
import { Role } from './profile';

export class Login {
  data: LoginData;
  error: any;
}

export class LoginData {
  user_id: number;
  first_name: string;
  last_name: string;
  company_id: number;
  company_name: string;
  impersonating: boolean;
  impersonating_admin_id: number;
  email: string;
  role: string;
  facility_id: number;
  facility_name: string;
  ex222_token: string;
  uid: string;
  tokenIsValid: boolean;
  token: string;
  use_cards: number;
  credit_overdraft: number;
  csos_enabled: boolean;
}

export class Users {
  data: UserData;
  error: any;
}

export class UserData {
  facilities: Facility[];
  roles: Role[];
  users: User[];
}

export type EmailStatus = 'verified' | 'unverified' | 'bad';

/** Rows from a stale facility index may lack email_status; derive it from email_confirmed. */
export function emailStatusOf(user: {
  email_status?: EmailStatus;
  email_confirmed?: boolean;
}): EmailStatus {
  return user.email_status ?? (user.email_confirmed ? 'verified' : 'unverified');
}

export class User {
  created_date: string;
  default_facility: number;
  email: string;
  first_name: string;
  id: number;
  image: string;
  last_name: string;
  phone: string;
  phone_ext: string;
  primary_facility: number;
  role: string;
  roles: number[];
  vett_status: string;
  email_confirmed: boolean;
  email_status: EmailStatus;
}

export const user_default: User = {
  created_date: '',
  default_facility: null,
  email: '',
  first_name: '',
  id: null,
  image: '',
  last_name: '',
  phone: '',
  phone_ext: '',
  primary_facility: null,
  role: '',
  roles: [],
  vett_status: 'Approved',
  email_confirmed: false,
  email_status: 'unverified',
};

export class NewPassword {
  password: string;
  match_password: string;
}
